import { request } from './client';

/**
 * Invitations: the league → player direction.
 *
 * Every other path is player → league — they enter a code and ask, and the
 * manager decides. This is the mirror: the manager picks people they know, and
 * each of them accepts or declines. Nobody is enrolled without agreeing, which
 * is what separates this from `miniLeagues.addMember`.
 */

/** Everything waiting on you to answer. */
export function getMine() {
  return request('/api/customer/invitations/mine');
}

/**
 * Who you could invite to this game or league: the people already in it, flagged
 * `inScope` so the picker can pre-tick them, plus the rest of your play history.
 * `alreadyInvited` marks anyone still to answer, so they show but cannot be picked.
 *
 * @param scope 'GAME' or 'MINI_LEAGUE'
 */
export function getCandidates(scope, scopeId) {
  return request(`/api/customer/invitations/candidates?scope=${scope}&scopeId=${scopeId}`);
}

/**
 * Manager only. Resolves with {invited: n}, which is deliberately not the number
 * picked — people already in, already asked, or who have declined once are
 * skipped rather than failing the whole batch.
 */
export function invite(scope, scopeId, playerIds) {
  return request('/api/customer/invitations', {
    method: 'POST',
    body: { scope, scopeId, playerIds },
  });
}

export function accept(invitationId) {
  return request(`/api/customer/invitations/${invitationId}/accept`, { method: 'POST' });
}

export function decline(invitationId) {
  return request(`/api/customer/invitations/${invitationId}/decline`, { method: 'POST' });
}
